import { Injectable, signal } from '@angular/core';
import { UserRepresentation, GroupRepresentation } from './keycloak-admin-api';

export interface SidebarState {
  isOpen: boolean;
  component: 'user-edit' | 'group-edit' | null;
  data?:
    | { userId: string; user?: UserRepresentation }
    | { groupId: string; group?: GroupRepresentation };
}

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private sidebarState = signal<SidebarState>({
    isOpen: false,
    component: null,
    data: undefined,
  });

  // Public read-only access to the sidebar state
  readonly state = this.sidebarState.asReadonly();

  openUserEdit(userId: string, user?: UserRepresentation) {
    this.sidebarState.set({
      isOpen: true,
      component: 'user-edit',
      data: { userId, user },
    });
  }

  openGroupEdit(groupId: string, group?: GroupRepresentation) {
    this.sidebarState.set({
      isOpen: true,
      component: 'group-edit',
      data: { groupId, group },
    });
  }

  closeSidebar() {
    this.sidebarState.set({
      isOpen: false,
      component: null,
      data: undefined,
    });
  }

  isOpen(): boolean {
    return this.sidebarState().isOpen;
  }

  getComponent(): string | null {
    return this.sidebarState().component;
  }

  getData(): SidebarState['data'] {
    return this.sidebarState().data;
  }
}
